import { render, staticRenderFns } from "./AppEmptyTable.vue?vue&type=template&id=27f93afc&"
import script from "./AppEmptyTable.vue?vue&type=script&lang=js&"
export * from "./AppEmptyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27f93afc')) {
      api.createRecord('27f93afc', component.options)
    } else {
      api.reload('27f93afc', component.options)
    }
    module.hot.accept("./AppEmptyTable.vue?vue&type=template&id=27f93afc&", function () {
      api.rerender('27f93afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppEmptyTable.vue"
export default component.exports